import { styled } from '@mui/material';
import { OutlinedInput, FormControl, InputLabel, FormHelperText, Box } from '@mui/material';

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
	width: '100%',
	marginBottom: theme.spacing(2),
}));

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
	'&.Mui-focused': {
		color: theme.palette.primary.main,
	},
	'&.Mui-error': {
		color: theme.palette.error.main,
	},
}));

export const StyledTextInput = styled(OutlinedInput, {
	shouldForwardProp: (prop) => !['hasStartAdornment', 'hasEndAdornment'].includes(prop as string),
})<{ hasStartAdornment?: boolean; hasEndAdornment?: boolean }>(({ theme, hasStartAdornment, hasEndAdornment, error }) => ({
	backgroundColor: (theme as any).palette.neutral.darker,
	borderRadius: (theme as any).shape.border.general.radius[4],
	height: "auto",
	'& .MuiOutlinedInput-notchedOutline': {
		border: "none",
	},

	'&:hover .MuiOutlinedInput-notchedOutline': {

	},
	'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: theme.palette.primary.main,
		borderWidth: 2,
	},
	'&.Mui-error .MuiOutlinedInput-notchedOutline': {
		borderColor: theme.palette.error.main,
	},
	'& .MuiOutlinedInput-input': {
		padding: theme.spacing(1, 1),
		marginLeft: theme.spacing(1)
	},
	"& .MuiInputBase-input::placeholder": {
		color: (theme as any).palette.neutral.main
	},

	// Ajustes de padding quando há adornments
	...(hasStartAdornment && {
		paddingLeft: theme.spacing(1),
	}),
	...(hasEndAdornment && {
		paddingRight: theme.spacing(1),
	}),
}));

export const StyledFormHelperText = styled(FormHelperText)(({ theme }) => ({
	marginLeft: 0,
	'&.Mui-error': {
		color: theme.palette.error.main,
	},
}));

export const AdornmentWrapper = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: theme.palette.text.secondary,

	'&.Mui-error': {
		color: theme.palette.error.main,
	},
}));